import styled from "@emotion/styled";
import React from "react";
import UI from "@mile-meeting/mile-ui";

type GoogleMeetingRoomNoticePopoverProps = {
  onClose: () => void;
  modalPosition: {
    top: number;
    left: number;
  };
  modalIsOpen: boolean;
};
const GoogleMeetingRoomNoticePopover: React.FC<GoogleMeetingRoomNoticePopoverProps> = ({
  onClose,
  modalIsOpen,
  modalPosition,
}: GoogleMeetingRoomNoticePopoverProps) => {
  return (
    <Container style={{ display: modalIsOpen ? "flex" : "none", top: modalPosition.top, left: modalPosition.left }}>
      <CancelBtn onClick={onClose}>
        <UI.Icon name="x" size={16} color="var(--alias-color-label-normal)" />
      </CancelBtn>
      <UI.Typography type="body01 normal" fontStyle="bold" color="var(--alias-color-label-normal)">
        구글 연동 회의실 유의사항
      </UI.Typography>
      <UI.Typography
        type="label01"
        fontStyle="regular"
        color="var(--alias-color-label-normal)"
        style={{
          whiteSpace: "pre-line",
        }}
      >
        <p>구글 리소스 캘린더에서 생성된 반복 예약은</p>
        <p>최소 참석 인원 제한이 적용되지 않습니다.</p>
      </UI.Typography>
    </Container>
  );
};

export default React.memo(GoogleMeetingRoomNoticePopover);

const Container = styled.div`
  position: absolute;
  border-radius: 8px;
  display: flex;
  max-width: 285px;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  background: var(--alias-color-background-normal-normal);
  box-shadow: var(--alias-style-shadow-strong);
`;

const CancelBtn = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;

  cursor: pointer;
`;
